import React, { Component } from 'react'
import NavbarItem from './NavbarItem'
import '../styles/Navbar.css'
import TicketIcon from '../images/icons/ticket.png'
import MagnifierIcon from '../images/icons/magnifier.png'
import BurgerIcon from '../images/Navbar/burger.png'
import SapinIcon from '../images/Navbar/sapinnoel.png'
import { injectIntl, defineMessages } from "react-intl"
import { Link, withRouter } from 'react-router-dom'
import smoothscroll from 'smoothscroll'
import MobileMenu from './MobileMenu'

class Navbar extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showThemesMenu: false,
      mobileMenu: false,
      themesMenu: false
    }
  }

  navbarStyle = () => {
    if (!this.props.isTop || this.state.mobileMenu) {
      return "navbar navbar-sticky"
    } else {
      return "navbar"
    }
  }

  goToSection = (path, id) => {
    if (this.props.location.pathname === path) {
      smoothscroll(document.getElementById(id))
    } else {
      this.props.history.push(`${path}#${id}`)
    }
  }

  toggleMobileMenu = () => {
    const menu = document.getElementById("mobile-menu-overlay")

    if (!this.state.mobileMenu) {
      this.setState({ mobileMenu: true }, () => {
        menu.style.display = "inline-block"
        window.setTimeout(x => {
          menu.style.opacity = 1
        }, 10)
      })
    } else {
      this.setState({ mobileMenu: false}, () => {
        menu.style.opacity = 0
        window.setTimeout(x => {
          menu.style.display = "none"
        }, 300)
      })
    }
  }

 render() {
    const {intl:{formatMessage}} = this.props
    return(
      <div className={`${this.navbarStyle()} ${this.props.style ? this.props.style : ""}`}>
		 <a class="banner" href="https://www.one-hour.fr/carte-cadeaux/"><div class="banner__content"><strong>🎅 Idée cadeau de Noël !</strong> Envie d'un cadeau insolite et original ? Pensez aux <u>cartes cadeaux</u> One Hour ! 🎄</div></a>
        <Link to="/">
          <div className="logo">
            <img className="magnifier" src={MagnifierIcon} alt="Escape game Paris"/>
            <div className="logo-text">
              <div className="one-hour-title">one hour</div>
              <div className="one-hour-baseline">Escape Game</div>
            </div>
          </div>
        </Link>
        {
          this.state.mobileMenu
          ?
          <div className="navigation-right-lang navigation-right-lang-mobile">
            <div onClick={(lang) => this.props.handleLang("fr")}>
              <NavbarItem lang={this.props.lang} title="FR"/>
            </div> |
            <div onClick={(lang) => this.props.handleLang("en")}>
              <NavbarItem lang={this.props.lang} title="EN" />
            </div>
            <div className="close" onClick={() => this.toggleMobileMenu()}/>
          </div>
          : <img className="navbar-burger" alt="burger" src={BurgerIcon} onClick={() => this.toggleMobileMenu()}/>
        }
        <div className="navbar-right">
          <div className="navigation-items">
            <NavbarItem
              toggle
              title={formatMessage(messages.themes)}
              openMenu={() => this.setState({ showThemesMenu: true })}
              closeMenu={() => this.setState({ showThemesMenu: false })}
              >
              <span className={this.state.showThemesMenu ? "navigation-item-arrow navigation-item-arrow--up" : "navigation-item-arrow"} />
              {
                this.state.showThemesMenu
                ?
                  <div className="navigation-scrolldown" onMouseOver={() => this.setState({ showThemesMenu: true})}>
                    <div className="navigation-scrolldown-content">
                      <div className="navigation-scrolldown-item navigation-scrolldown-item--category">One Hour Charonne</div>
                      <Link to="/lost-asylum/"><div className="navigation-scrolldown-item"><span>{formatMessage(messages.la)}</span></div></Link>
                      <Link to="/very-bad-night/"><div className="navigation-scrolldown-item"><span>{formatMessage(messages.VBN)}</span></div></Link>
                      <div className="navigation-scrolldown-item navigation-scrolldown-item--category">One Hour Voltaire</div>
                      <Link to="/abattoir/"><div className="navigation-scrolldown-item"><span>{formatMessage(messages.slaughterhouse)}</span></div></Link>
                      <Link to="/yakuza/"><div className="navigation-scrolldown-item"><span>{formatMessage(messages.yakuza)}</span></div></Link>
					  <Link to="/expedition-maudite/"><div className="navigation-scrolldown-item"><span>{formatMessage(messages.expeditionmaudite)}</span></div></Link>
                    </div>
                  </div>
                : null
              }

            </NavbarItem>
            <Link to="/team-building/">
              <NavbarItem title={formatMessage(messages.teambuilding)}/>
            </Link>
            <Link to="/carte-cadeaux/">
              <NavbarItem title={formatMessage(messages.giftCard)}/>
            </Link>
            <div className="navigation-right-lang">
              <div className="navigation-lang-item" onClick={(lang) => this.props.handleLang("fr")}>
                <NavbarItem lang={this.props.lang} title="FR"/>
              </div>
              <div className="navigation-lang-separator">|</div>
              <div className="navigation-lang-item" onClick={(lang) => this.props.handleLang("en")}>
                <NavbarItem lang={this.props.lang} title="EN"/>
              </div>
            </div>
          </div>
          <Link to="/reserver/">
            <div className="cta-booking">
              <div className="ticket-container">
                <img className="ticket" src={TicketIcon} alt="ticket-icon"/>
                <div className="cta-booking-text">{formatMessage(messages.book)}</div>
              </div>
            </div>
          </Link>
        </div>
        <MobileMenu />
      </div>
    )
  }
}

const messages = defineMessages({
  book: {
    id: 'navbar.cta',
    defaultMessage: 'Réserver'
  },
  teambuilding: {
    id: 'navbar.teambuilding',
    defaultMessage: 'TeamBuilding'
  },
  giftCard: {
    id: 'navbar.giftcard',
    defaultMessage: 'Carte Cadeaux'
  },
  themes: {
    id: 'navbar.themes',
    defaultMessage: 'Les thèmes'
  },
  slaughterhouse: {
    id: 'themes.slaughterhouse',
    defaultMessage: "L'abattoir"
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: "Yakuza"
  },
  VBN: {
    id: 'themes.VBN',
    defaultMessage: "Very Bad Night"
  },
  la: {
    id: 'themes.la',
    defaultMessage: "Lost Asylum"
  },
  expeditionmaudite: {
    id: 'themes.exp',
    defaultMessage: "Expédition Maudite"
  }
})

export default withRouter(injectIntl(Navbar))



// WEBPACK FOOTER //
// ./src/components/Navbar.js